export default __webpack_public_path__ + "static/media/now-you-try.f6a45186.mp3";